import { FormHelperText } from '@mui/material'
import UploadBox from 'components/UploadDialog/UploadBox'

function OcrSettingsUploadBox({ handleFilesAdded, handleFileDeleted, errors, fileData }) {
  const files = fileData ? [fileData] : []
  return (
    <>
      <UploadBox
        showHint={false}
        files={files}
        onAddFiles={handleFilesAdded}
        onDeleteFile={handleFileDeleted}
      />
      {errors.map((errorMessage) => (
        <FormHelperText key={errorMessage} error>
          {errorMessage}
        </FormHelperText>
      ))}
    </>
  )
}

export default OcrSettingsUploadBox
